import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useForm, Controller } from "react-hook-form";
import { Button, MultiSelect, MultiSelectItem, TextInput } from "@tremor/react";
import { TitlePageInfo } from "../components";
import { adminAPI } from "../../api/adminAPI";
import { useNavigate, useParams } from "react-router-dom";
import { AlertBox } from "../../ui";

const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const FormProfileAdminLayout = ({
  isEditMode = false,
  titlePage = "",
}) => {
  const { jwt } = useSelector((state) => state.auth);
  const [tables, setTables] = useState([]);
  const [name, setName] = useState("");
  const [selectedPermissions, setSelectedPermissions] = useState([]);
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    control,
    setValue,
    formState: { errors, isSubmitting },
  } = useForm();

  //This props is only used whee is editMode =true
  const { id } = useParams();
  const [profile, setProfile] = useState(null);
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    if (!isEditMode || !profile) return;

    tables.map((tableInformation) => {
      const { permissions, table } = tableInformation;
      const profilePermissions = profile.profilePermissions.map(
        (p) => p.permissionId
      );
      const permissionsInTable = permissions.map((p) => p.id);
      const selectedPermissions = profilePermissions.filter(
        (p) => permissionsInTable.includes(p) === true
      );
      setValue(table, selectedPermissions);
      // setValues(selectedPermissions, table);
    });
  }, [profile]);

  useEffect(() => {
    getProfiles();
    if (isEditMode) {
      getProfile(id);
    }
  }, [id, isEditMode]);

  const getProfile = async (id = 0) => {
    setLoading(true);
    const resp = await adminAPI
      .get(`/profile/${id}`, {
        headers: { "x-token": jwt },
      })
      .catch(({ response }) => response);

    const { data } = resp.data;
    setValue("name", data.name);

    if (resp.status !== 200) {
      const errors = data.message
        ? [data.message]
        : data.errors.map((err) => err.msg);
      AlertBox({ color: "warning", messages: errors });
    }
    setProfile(data);
    setName(data.name);
    setLoading(false);
  };

  const getProfiles = async () => {
    setLoading(true);
    const resp = await adminAPI
      .get("/profile/permissions-per-profile", {
        headers: { "x-token": jwt },
      })
      .catch(({ response }) => response);
    if (resp.status !== 200) {
      console.log("ERROR");
    }
    const { data } = resp.data;
    setTables(data);
    setLoading(false);
  };

  const setValues = (values, tableIndex) => {
    setSelectedPermissions((prevState) => ({
      ...prevState,
      [tableIndex]: values,
    }));
  };

  const onSubmit = async (dataValues) => {
    const { name, ...permissionsToFilter } = dataValues;
    const permissionsID = Object.values(permissionsToFilter)
      .filter((p) => p !== undefined)
      .flat();

    const dataForm = {
      permissionsID,
      name,
    };
    const url = isEditMode ? `/profile/${id}` : "/profile";
    const method = isEditMode ? "patch" : "post";
    const headers = {
      "x-token": jwt,
    };
    const resp = await adminAPI[method](url, dataForm, { headers }).catch(
      ({ response }) => response
    );

    if (resp.status === 200) {
      AlertBox({ color: "success", messages: ["Perfil Guardado"] });
      navigate("/admin/profiles");
      return;
    }
    const { data } = resp;
    const errors = data.message
      ? [data.message]
      : data.errors.map((err) => err.msg);
    AlertBox({ color: "warning", messages: errors });
  };

  return (
    <>
      <TitlePageInfo title={titlePage} />
      <form onSubmit={handleSubmit(onSubmit)}>
        <div>
          <p>Nombre de Perfil</p>
          <TextInput
            type="text"
            className="w-full"
            placeholder="Perfil 1"
            name="name"
            {...register("name", {
              required: {
                value: true,
                message: "Debe contener Nombre el perfil",
              },
              minLength: {
                value: 2,
                message: "Debe contener al menos 2 caracteres",
              },
            })}
          />
          {errors.name && (
            <p className="text-red-500 text-xs italic">{errors.name.message}</p>
          )}
        </div>
        {tables.length > 0 && !isLoading ? (
          tables.map(({ table, translatedTable, permissions }) => (
            <div className="grid grid-cols-3 mt-3 gap-3" key={table}>
              <div className="text-2xl">
                {capitalizeFirstLetter(translatedTable)}
              </div>
              <div>
                <Controller
                  name={table}
                  control={control}
                  render={({ field }) => (
                    <>
                      <MultiSelect
                        placeholder="Seleccionar Permisos..."
                        name={table}
                        value={selectedPermissions[table]}
                        {...field}
                      >
                        {permissions.map((permission) => (
                          <MultiSelectItem
                            key={permission.id}
                            value={permission.id}
                          >
                            {capitalizeFirstLetter(
                              permission.translatedPermission
                            )}
                          </MultiSelectItem>
                        ))}
                      </MultiSelect>
                      {errors[table] && (
                        <p className="text-red-500 text-xs italic">
                          {errors[table].message}
                        </p>
                      )}
                    </>
                  )}
                />
              </div>
            </div>
          ))
        ) : (
          <></>
        )}
        <div className="flex justify-end mt-2">
          <Button type="submit" disabled={isSubmitting}>
            {isSubmitting ? (isEditMode ? "Editando..." : "Guardando...") : (isEditMode ? "Editar" : "Guardar")}
          </Button>
        </div>
      </form>
    </>
  );
};

FormProfileAdminLayout.propTypes = {
  isEditMode: PropTypes.bool,
  titlePage: PropTypes.string,
};
